import { apiUrl } from '@/api/base.js'
import axios from 'axios'

export default {
    get_question_list (questionListArgs) {
        return axios.get(apiUrl + 'v2/questions', {params: questionListArgs})
    },
    get_lesson_or_my_question_list (questionListArgs) {
        return axios.get(apiUrl + 'v2/lesson_or_my_questions', {params: questionListArgs})
    },
}
